module.exports = __webpack_public_path__ + "static/media/ipfs-logo.4831bd1a.svg";